import { numberLocaleFor } from "../i18n/locale";
import type { Locale } from "../i18n/locale";
import type { SensitivityDeltas } from "../lib/sensitivity";
import type { UiKey } from "../i18n/ui";

type Props = {
  locale: Locale;
  t: (key: UiKey) => string;
  deltas: SensitivityDeltas;
};

export function SensitivityCard({ locale, t, deltas }: Props) {
  const nf = numberLocaleFor(locale);
  const money = (n: number) =>
    (n >= 0 ? "+" : "") +
    n.toLocaleString(nf, {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    });

  return (
    <div>
      <h2>{t("sensitivity.title")}</h2>
      <ul className="list">
        <li>
          <span>{t("sensitivity.dau")}</span>
          <strong>{money(deltas.dauPlus10Usd)}</strong>
        </li>
        <li>
          <span>{t("sensitivity.req")}</span>
          <strong>{money(deltas.requestsPlus10Usd)}</strong>
        </li>
        <li>
          <span>{t("sensitivity.aiShare")}</span>
          <strong>{money(deltas.aiSharePlus10Usd)}</strong>
        </li>
        <li>
          <span>{t("sensitivity.tokens")}</span>
          <strong>{money(deltas.tokensPlus10Usd)}</strong>
        </li>
      </ul>
      <style>{`
        h2 {
          font-size: 1rem;
          margin: 0 0 0.75rem;
        }
        .list {
          list-style: none;
          margin: 0;
          padding: 0;
        }
        .list li {
          display: flex;
          justify-content: space-between;
          gap: 1rem;
          padding: 0.5rem 0;
          border-bottom: 1px solid var(--border);
          font-size: 0.9rem;
        }
        .list li:last-child {
          border-bottom: none;
        }
        .list strong {
          font-family: var(--mono);
          color: var(--accent);
        }
      `}</style>
    </div>
  );
}
